<template>
  <div>
    <v-col cols="12">
      <v-tabs v-model="tab" background-color="primary" dark>
        <v-tab> AWS </v-tab>
        <v-tab> Vultr </v-tab>
      </v-tabs>

      <v-tabs-items v-model="tab">
        <!-- Fulfillment -->
        <v-tab-item>
          <v-card>
            <vpsAws />
          </v-card>
        </v-tab-item>

        <!-- Tracking -->
        <v-tab-item>
          <v-card>
            <vpsVultr />
          </v-card>
        </v-tab-item>
      </v-tabs-items>
    </v-col>
  </div>
</template>


<script>
//import HTTP from "../http-common"
//import Vue from "vue";
//import moment from 'moment-timezone'
import axios from "axios";
import vpsAws from "./c-aws";
import vpsVultr from "./c-vultr";
//import Amplify, { Auth } from 'aws-amplify';

// Amplify.configure({
//   Auth: {
//       region: 'ap-southeast-1',
//       userPoolId: 'ap-southeast-1_8vBdk5PAd',
//       userPoolWebClientId: '51e572vhkn38k7tuvsdst697b1',
//       mandatorySignIn: true,
//   }
// });

export default {
  name: "Sites",
  components: {
    vpsAws,
    vpsVultr,
  },
  //new Vue({
  data: () => ({
    loading: null,
    week: "",
    tab: null,
    listFulfillment: {},
    listTracking: {},
    menu2: false,
    dates: [],
    roles: [],
  }),

  computed: {
    dateRangeText() {
      return this.dates.join(" ~ ");
    },
  },

  methods: {
    async loadData() {
      this.loading = true;
      this.listFulfillment = {};
      this.listTracking = {};
      var currentSession = await this.$root.$refs.App.currentSession(
        "backend-loadData"
      );

      if (currentSession.accessToken) {
        let queryParams = {};
        //report_week: this.week
        if (this.dates[0] > this.dates[1]) {
          queryParams["report_from"] = this.dates[1];
          queryParams["report_to"] = this.dates[0];
        } else {
          queryParams["report_from"] = this.dates[0];
          queryParams["report_to"] = this.dates[1];
        }
        await axios
          .get(window.domain + "reports/backend", {
            headers: { Authorization: currentSession.accessToken },
            params: queryParams,
          })
          .then((response) => {
            // console.log(this.AuthStr)
            console.log("backend Response: ", response);
            this.listFulfillment = response.data.data.Fulfill;
            this.listTracking = response.data.data.Tracking;
            this.loading = false;
          })
          .catch((error) => {
            console.log("Error:", error);
          });
      } else {
        console.log(
          "currentSession backend-loadData-undefined: ",
          currentSession
        );
      }
    },

    checkRoles(str) {
      var a = this.$root.$refs.App.hashCode(str);

      if (this.$cookies.get("roles") != null) {
        var role = this.$cookies.get("roles").split(",");
        var index = role.indexOf(a.toString());
        if (index != -1) return true;
        else return false;
      } else return false;
    },
  },
  async mounted() {
    //console.log("loading: ", this.loading);
    this.roles = await this.$cookies.get("vps");
    if (this.roles.list_vps) {
      console.log("OK");
    } else {
      this.$router.push("/not-authorized");
    }
  },
};
</script>